import { render, staticRenderFns } from "./TitularidadeIngressoModal.vue?vue&type=template&id=6efcb925&scoped=true"
import script from "./TitularidadeIngressoModal.vue?vue&type=script&lang=js"
export * from "./TitularidadeIngressoModal.vue?vue&type=script&lang=js"
import style0 from "./TitularidadeIngressoModal.vue?vue&type=style&index=0&id=6efcb925&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efcb925",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VTooltip})
